import React, {
    createContext,
    useState,
    // useEffect,
    ReactNode,
    Dispatch,
    SetStateAction,
} from "react";

interface AuthContextType {
    isLoggedIn: boolean;
    setIsLoggedIn: Dispatch<SetStateAction<boolean>>;
    ogToken: string | null;
    setOgToken: Dispatch<SetStateAction<string | null>>;
    ogOrgId: string | null;
    setOgOrgId: Dispatch<SetStateAction<string | null>>;
    ogAccessPoint: string | null;
    setOgAccessPoint: Dispatch<SetStateAction<string | null>>;
    googleProfile: any;
    setGoogleProfile: Dispatch<SetStateAction<any>>;
    googleIdToken: string | null;
    setGoogleIdToken: Dispatch<SetStateAction<string | null>>;
    ogRefreshToken: string | null;
    setOgRefreshToken: Dispatch<SetStateAction<string | null>>;
    errorMessage: string | null;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [ogToken, setOgToken] = useState<string | null>(null);
    const [ogRefreshToken, setOgRefreshToken] = useState<string | null>(null);
    const [ogOrgId, setOgOrgId] = useState<string | null>(null);
    const [ogAccessPoint, setOgAccessPoint] = useState<string | null>(null);
    const [googleProfile, setGoogleProfile] = useState<any>(null);
    const [googleIdToken, setGoogleIdToken] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    return (
        <AuthContext.Provider
            value={{
                isLoggedIn,
                setIsLoggedIn,
                ogToken,
                setOgToken,
                ogOrgId,
                setOgOrgId,
                ogAccessPoint,
                setOgAccessPoint,
                googleProfile,
                setGoogleProfile,
                googleIdToken,
                setGoogleIdToken,
                ogRefreshToken,
                setOgRefreshToken,
                errorMessage,
                setErrorMessage,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
